export const defaultFontFamilies = {
	base: "'Open Sans', -apple-system, 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
} as const;

export type FontFamilies = typeof defaultFontFamilies;
